import React from 'react'
import AdminPage from 'pages/app/AdminPage'
import { Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Collection, ForEachModel, ValueToCollection, WhenModelValue } from '@morningtrain/react-resources'
import * as Accordion from 'support/utilities/accordions'
import * as Displays from 'support/displays'

export default function Overview () {
  return (
    <AdminPage>
      <Translator namespace='suppliers'>
        <UI.PageHeader title={<TranslatedTitle name='titles.overview'/>}/>
        <Collection resourceName='department_suppliers' operationName='tablet'>
          <Accordion.Accordion>
            <ForEachModel>
              <Accordion.ModelItem
                transparent
                modelName='id'
                title={(
                  <UI.SecondaryHeading>
                    <Displays.Text name='name'/>
                  </UI.SecondaryHeading>
                )}
              >
                <ValueToCollection name='contacts'>

                  <UI.CardGroup>
                    <UI.HorizontalList className='border-t' justify='left'>
                      <ForEachModel>
                        <UI.CardWithHeader header={<Displays.Text name='name'/>} className='m-4'>
                          <div><Displays.Text name='position'/></div>

                          <WhenModelValue name='email'>
                            <Displays.Email name='email'/>
                          </WhenModelValue>

                          <WhenModelValue name='phone'>
                            <Displays.Phone name='phone'/>
                          </WhenModelValue>
                        </UI.CardWithHeader>
                      </ForEachModel>
                    </UI.HorizontalList>
                  </UI.CardGroup>

                </ValueToCollection>
              </Accordion.ModelItem>
            </ForEachModel>
          </Accordion.Accordion>
        </Collection>
      </Translator>
    </AdminPage>
  )
}
